export default "__VITE_ASSET__08126169__"